import { render, staticRenderFns } from "./ModalBillingConfirmRemoveAddress.vue?vue&type=template&id=910d499a&scoped=true&"
import script from "./ModalBillingConfirmRemoveAddress.vue?vue&type=script&lang=js&"
export * from "./ModalBillingConfirmRemoveAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910d499a",
  null
  
)

export default component.exports